import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Junta classes resolvendo conflitos do Tailwind.
 *
 * Sem o merge, `cn('p-2', 'p-4')` deixaria as duas na string e o resultado
 * dependeria da ordem no CSS gerado, não da ordem da chamada.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
